import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface NavigationInformation {
  screen: number;
}

const initialState = {
  NavigationInformation: {
    screen: 0,
    bar: 'close',
    RouteDetailModal: { showModal: false, plan: {} },
    RouteDescriptionModal: { showModal: false, plan: {} },
  },
};

export const navigationSlice = createSlice({
  name: 'navigationSlice',
  initialState,
  reducers: {
    updateScreen: (state, action) => {
      state.NavigationInformation.screen = action.payload;
    },
    updateRouteDetailModal: (state, action?) => {
      state.NavigationInformation.RouteDetailModal.showModal = action.payload.showModal;
      state.NavigationInformation.RouteDetailModal.plan = action.payload.plan;
    },
    updateRouteDescriptionModal: (state, action?) => {
      state.NavigationInformation.RouteDescriptionModal.showModal = action.payload.showModal;
      state.NavigationInformation.RouteDescriptionModal.plan = action.payload.plan;
    },
    updateBar: (state?) => {
      if (state.NavigationInformation.bar === 'close') state.NavigationInformation.bar = 'open';
      else state.NavigationInformation.bar = 'close';
    },
  },
});

export const { updateScreen, updateBar } = navigationSlice.actions;

export const navigationInformation = (state: RootState) =>
  state.navigationSlice.NavigationInformation;
